import { Folder } from "@mui/icons-material";
import { Box, Button, Chip, TableCell, TableRow, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import SearchFolderIcon from '../../../../../../assets/icons/icon-search-folder.svg';
import { WorkSpaceUserName } from "../../../../../../model/ItemModel";
import { KeyDriveTable } from "../../../../../../components/KeydriveComponents/Tables/KeyDriveTable";
import { KeyDriveBodyMin } from "../../../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import WorkSpaceItemListFileComponentImage, { returnComp } from "../../../../../WorkSpaceItem/WorkSpaceItemListFileComponentImage";
import moment from "moment";
import { returnByteWithNotation } from "../../../../../../utils/ReturnByteWithNotation";
import { ClockField } from "../../../../../WorkSpaceItem/WorkSpaceItemListFileCompose/ClockField";
import { useEffect, useState } from "react";
import LoaderComp from "../../../../../../components/Loader/LoaderComp";
import { useNavigate, useParams } from "react-router-dom";
interface DocumentsListProps {
    items: WorkSpaceUserName[];
}





export const DocumentsList: React.FC<DocumentsListProps> = ({ items }) => {
    const { t } = useTranslation();
    const { nameOrg, idWorkspace } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(true);
    const headerTable = [
        t("DocumentsList.DocumentsTableHeaders.Name"),
        t("DocumentsList.DocumentsTableHeaders.Description"),
        t("DocumentsList.DocumentsTableHeaders.CreatedAt"),
        t("DocumentsList.DocumentsTableHeaders.Tags"),
        t("DocumentsList.DocumentsTableHeaders.Size"),
        t("DocumentsList.DocumentsTableHeaders.Term")];
    useEffect(() => {
        if (items.length >= 0) {
            setLoading(false)
        }
    })

    function notFoundFilesAndFolders() {
        return <div style={{
            height: 'calc(100vh - 407px)',
            border: '1px solid #e0e0e0',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '340px',
                textAlign: 'center',
                gap: '20px'
            }}>
                <img src={SearchFolderIcon} style={{ marginBottom: '20px' }} />
                <div>
                    <Typography sx={{
                        font: 'normal normal 600 18px/27px Segoe UI',
                        color: '#2D2D2D',
                        marginBottom: '8px'
                    }}>Não há Documentos aqui</Typography>
                    <Typography sx={{
                        font: 'normal normal normal 14px/21px Segoe UI',
                        color: '#969696',
                    }}>Para visualizar os documentos, retorne para a sua Conta e navegue pelos documentos do workspace.
                    </Typography>
                </div>
                {btnSeeMoreDocuments()}
            </div>
        </div>
    }
    
    function btnSeeMoreDocuments() {
        return <Button
            variant="contained"
            startIcon={<Folder />}
            sx={{
                height: '36px',
                backgroundColor: '#22638D',
                textTransform: 'none',
                font: 'normal normal normal 14px/21px Segoe UI',
                whiteSpace: 'nowrap'
            }}
         onClick={(e)=> navigate(`/${nameOrg}/wsallowed/${idWorkspace}`)}
        >
            {t("DocumentsList.SeeDocuments")}
        </Button>
    }

    return (
        <>
            {loading ? (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <LoaderComp />
                </Box>

            ) : (
                items.length <= 0 ? (
                    notFoundFilesAndFolders()
                ) : (
                    <>
                        <KeyDriveTable headers={headerTable}
                            body={items.map(item => (
                                <TableRow style={{ padding: '5px 0' }}>
                                    <TableCell sx={{ paddingRight: '8px', paddingLeft: "8px", paddingBottom: 0, paddingTop: 0 }}>
                                        <KeyDriveBodyMin
                                            color="#2D2D2D"
                                            needBold
                                            needEllipses={false}
                                            text={""}
                                        />
                                        <WorkSpaceItemListFileComponentImage extension={item.extension} isFolder={item.itemType === "folder"} />
                                    </TableCell>
                                    <TableCell sx={{ paddingRight: '8px', paddingLeft: "8px", paddingBottom: 0, paddingTop: 0 }}>
                                        <KeyDriveBodyMin
                                            color="#2D2D2D"
                                            needBold
                                            needEllipses={false}
                                            text={item?.name!}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ paddingRight: '8px', paddingLeft: "8px", paddingBottom: 0, paddingTop: 0 }}>
                                        <KeyDriveBodyMin
                                            color="#2D2D2D"
                                            needBold
                                            needEllipses={false}
                                            text={item?.description!}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ paddingRight: '8px', paddingLeft: "8px", paddingBottom: 0, paddingTop: 0 }}>
                                        <KeyDriveBodyMin
                                            color="#2D2D2D"
                                            needBold
                                            needEllipses={false}
                                            text={moment(item.lastWriteDate).format("DD/MM/YYYY")}
                                        />

                                    </TableCell>
                                    <TableCell sx={{ paddingRight: '8px', paddingLeft: "8px", paddingBottom: 0, paddingTop: 0 }}>
                                        <KeyDriveBodyMin
                                            color="#2D2D2D"
                                            needBold
                                            needEllipses={false}
                                            text={''}
                                        />
                                        {item.tagName.map(tag => (<Chip style={{ height: '20px' }} key={tag.idTag} label={tag.name} variant="outlined" />))}
                                    </TableCell>
                                    <TableCell sx={{ paddingRight: '8px', paddingLeft: "8px", paddingBottom: 0, paddingTop: 0 }}>
                                        <KeyDriveBodyMin
                                            color="#2D2D2D"
                                            needBold
                                            needEllipses={false}
                                            text={''}
                                        />
                                        {item.itemType == "file" &&
                                            returnByteWithNotation(item.size)}
                                    </TableCell>
                                    <TableCell sx={{ paddingRight: '8px', paddingLeft: "8px", paddingBottom: 0, paddingTop: 0 }}>
                                        <KeyDriveBodyMin
                                            color="#2D2D2D"
                                            needBold
                                            needEllipses={false}
                                            text={""}
                                        />
                                        <ClockField
                                            isReleaseConst={item.isRelease}
                                            timeDeadLine={item.validationRule?.timeDeadline}
                                            validatioRule={item.validationRule}
                                            itemTemporality={item.itemTemporality}
                                        />
                                    </TableCell>

                                </TableRow>
                            ))} needFooter={false} />
                        <div style={{ display: 'flex', justifyContent: 'center', margin: '10px 0' }}>
                            {btnSeeMoreDocuments()}
                        </div>
                    </>
                )
            )}

        </>
    )
}